module.exports = __webpack_public_path__ + "public/img/ico-arrow-language-switch.9e38457f.svg";